export enum ServiceRequestStepType {
  Shipping = 1,
  Details = 2,
  Review = 3,
  Confirmation = 4,
}

export const FormsIds = {
  [ServiceRequestStepType.Shipping]: "service-request-step1-form",
  [ServiceRequestStepType.Details]: "service-request-step2-form",
  [ServiceRequestStepType.Review]: "service-request-step3-form",
};
